(function() {
  function initAnnouncementBarSwiper() {
    if (typeof Swiper !== 'undefined') {
      const announcementBarSwiper = document.querySelectorAll('.announcement-bar-swiper');

      announcementBarSwiper.forEach(announcementBarSwiper => {
        const rawConfig = announcementBarSwiper.querySelector('.swiper-wrapper').dataset.swiperObject;
        if (!rawConfig) return;
        const swiperObject = JSON.parse(rawConfig);
        new Swiper(announcementBarSwiper, swiperObject);
      });
      return true;
    }
    return false;
  }

  function waitForSwiper() {
    if (!initAnnouncementBarSwiper()) {
      setTimeout(waitForSwiper, 100);
    }
  }

  waitForSwiper();
})();
